import { flyweight } from 'commons/util/interfaces';
import { REST } from 'commons/rest/rest.js';
import httpClient from '@/resources/http-client.js';
import options from 'config';
import { refreshUserToken } from '@/resources/auth.js';
import { authorizationRequestInterceptor, createRefreshRetryHandler } from '@/resources/auth-token.js';

/**
 * RestAPIV4 - basic wrapper over XMLHttpRequest for using V4 API
 *
 * @param {string} baseURL - base url
 * @constructor
 */
export function RestAPIV4(baseURL) {
    REST.call(this, httpClient, baseURL);

    this.api.interceptors.request.use(authorizationRequestInterceptor);
    this.api.interceptors.response.use((response) => response.data.result || response.data,
        createRefreshRetryHandler(this.api, refreshUserToken));
}

export const sendBeaconDeleteBatch = (batch_uuid) => {
    navigator.sendBeacon(`${options.console_api_url}/batch/${batch_uuid}/delete`);
};

export const sendAnalyticsBeacon = (event) => {
    navigator.sendBeacon(
        `${options.console_api_url}/analytics/users/event`,
        new Blob([ JSON.stringify(event) ], {
            type: 'application/json;charset=UTF-8',
        }),
    );
};

RestAPIV4.prototype = Object.create(REST.prototype);

export const restAPIV4 = flyweight(RestAPIV4);
